import type { Map as MlMap } from "maplibre-gl";
import { usePolledRef } from "./use-polled-ref";

interface HandleWithMap {
  readonly map: MlMap | null;
}

/**
 * Polls a LogisticsMap/Map ref until its underlying maplibre-gl instance
 * exists. Neither component exposes an onReady callback to wrapping code —
 * `handle.map` only stops being null once its internal "ready" state flips —
 * so this is the only way to know from the outside.
 */
export function useMapReady<H extends HandleWithMap>(ref: React.RefObject<H | null>): MlMap | null {
  return usePolledRef(ref, (h) => h.map);
}
